const repositionCard = (params) => {
  const { editor, currentNodeKey, newParentKey, newCardIndex } = params;
  editor.moveNodeByKey(currentNodeKey, newParentKey, newCardIndex);
};

/**
 * Re position the dragging card and re-arrange the other cards accordingly
 */
export const rearrangeOnDraggingBetweenElements = (params) => {
  const { dragType, editor, currentNodeKey, parent } = params;
  const { key: newParentKey } = parent;

  let newCardIndex;

  if (dragType === 'ORGANIZATION') {
    const { afterOrgNodeOrdinal, currOrgNodeOrdinal } = params;
    const { orgIndex } = params;
    newCardIndex = orgIndex;
    if (afterOrgNodeOrdinal > currOrgNodeOrdinal) {
      newCardIndex = afterOrgNodeOrdinal - 2;
    } else if (afterOrgNodeOrdinal < currOrgNodeOrdinal) {
      newCardIndex = Math.max(afterOrgNodeOrdinal, 1) - 1;
    }
  } else if (
    dragType === 'ROLE' ||
    dragType === 'ROLE_ARRAY_ITEM' ||
    dragType === 'ARRAY_ITEM'
  ) {
    const { afterRoleNode } = params;
    const { nodes: parentNodes } = parent;
    const afterRoleIndex = parentNodes.indexOf(afterRoleNode);
    if (afterRoleIndex === 1) {
      newCardIndex = afterRoleIndex;
    } else if (afterRoleIndex > 1) {
      const currentNode = editor.value.document.getNode(currentNodeKey);
      const currentNodeIndex = parentNodes.indexOf(currentNode);
      if (currentNodeIndex > afterRoleIndex) {
        newCardIndex = afterRoleIndex;
      } else {
        newCardIndex = afterRoleIndex - 1;
      }
    } else if (afterRoleIndex === -1) {
      const { size: parentNodesSize } = parentNodes;
      newCardIndex = parentNodesSize;
    }
    // Array item on top of its siblings
    else if (afterRoleIndex === 0) {
      newCardIndex = afterRoleIndex;
    }
  }

  repositionCard({
    editor,
    currentNodeKey,
    newParentKey,
    newCardIndex,
    dragType,
  });

  if (dragType === 'ORGANIZATION') {
    return { orgIndex: newCardIndex };
  }

  return null;
};

export const rearrangeOnDraggingAtEndOfElements = (params) => {
  const {
    editor,
    currentNodeKey,
    parent,
    nextEmptyParaKey,
    newIndex,
    dragType,
  } = params;

  let newCardIndex = newIndex;

  if (dragType === 'ARRAY_ITEM') {
    newCardIndex = newIndex - 1;
  }

  repositionCard({
    editor,
    currentNodeKey,
    newParentKey: parent.key,
    nextEmptyParaKey,
    newCardIndex,
    dragType,
  });
};
